<!-- TODO manage payments failing -->

<div *ngIf="!isAutoRenewal && order" class="card-dashboard p-3">
    <div class="d-flex justify-content-between">
        <div class="d-flex flex-row">
            <div class="d-flex me-2">
                <div class="icp-car-default icp-icon-40"></div>
            </div>
            <div class="d-flex flex-column pe-2">
                <strong>
                    <p class="m-0" *ngIf="order && order.NE__Service_Point__r.Brand__c && order.NE__Service_Point__r.Model__c">
                        {{order.NE__Service_Point__r.Brand__c}} {{order.NE__Service_Point__r.Model__c}}</p>
                </strong>
                <p class="m-0" *ngIf="order && order.NE__Cart_Description__c">
                    {{order.NE__Cart_Description__c}}
                </p>
                <p class="m-0">
                    <span *ngIf="order.NE__OrderId__r.Order_Duration__c === 1">{{order.NE__OrderId__r.Order_Duration__c}} {{"durations-month-text" | translate}}</span>
                    <span *ngIf="order.NE__OrderId__r.Order_Duration__c > 1 && rest !== 0">{{order.NE__OrderId__r.Order_Duration__c}} {{"durations-months-text" | translate}}</span>
                    <span *ngIf="order.NE__OrderId__r.Order_Duration__c > 12 && rest === 0 || order.NE__OrderId__r.Order_Duration__c === 0">{{order.NE__OrderId__r.Order_Duration__c | monthsToYears}} {{years[1]}}</span>
                    <span *ngIf="order.NE__OrderId__r.Order_Duration__c === 12 && rest === 0">{{order.NE__OrderId__r.Order_Duration__c | monthsToYears}} {{years[0]}}</span>
                </p>
                <p class="m-0"><strong>{{price}} </strong></p>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-end"><p *ngIf="price && discount" class="c-red mb-0 text-end">{{discount}}</p></div>
    </div>
</div>

<ng-container *ngIf="!canPay && paymentMethods?.[0]?.payment_method_type">
    <ng-container *ngIf="order.is_automatic_renewal_available && isOnboardingPayment && order.NE__OrderId__r.Order_Duration__c < ONBOARDING_AUTORENEWAL_FOR_DURATIONS">
        <div class="px-2 pt-3">
            <ng-container *ngIf="order.is_automatic_renewal_available">
                <div class="d-flex justify-content-between align-items-center px-2">
                    <mat-checkbox [(ngModel)]="order.automatic_renewal" (ngModelChange)="changeAutorenewalChecked($event)" class="text-truncate" [disabled]="waitSave">
                        {{"subscription-renewal-payment-checkbox-text" | translate}}
                    </mat-checkbox>
                    <div #tooltip="matTooltip" [matTooltip]="'subscription-renewal-payment-onboarding-tooltip' | translate" matTooltipPosition="above">
                        <div class="icp-icon-32 icp-info-tooltip pt-2"></div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="py-2">
            <hr class="w-50 mx-auto my-4" />
        </div>
    </ng-container>
    <p>{{"subscription-renewal-payment-title" | translate}}</p>
    <mat-radio-group class="d-flex flex-column" [(ngModel)]="selectedPaymentMethod">
        <mat-radio-button *ngFor="let method of paymentMethods" class="rounded-box mb-3 mt-0" [value]="method" [disabled]="!method.selectable">
            <p>{{PAYMENT_METHOD_KEY_PREFIX + method.payment_method_type.replace("_", "-") | translate}}</p>
        </mat-radio-button>
    </mat-radio-group>

    <button *ngIf="!canPay" [disabled]="waitPay || !selectedPaymentMethod" class="btn btn-primary mt-5 mb-3 w-100"
        (click)="init(selectedPaymentMethod)">
        <span *ngIf="!waitPay">{{"order-detail-payment-action-confirm" | translate}}</span>
        <span *ngIf="waitPay">{{"common-waiting" | translate}}</span>
    </button>
</ng-container>

<div  *ngIf="paymentMethods?.[0]?.payment_method_code" class="d-flex flex-column justify-content-center align-items-center" [class.d-none]="!customPayment">
    <hr class="w-50 mx-auto my-3" />
    <p>{{PAYMENT_INFO_FIRST + paymentMethods[0].payment_method_code.replace("_", "-") | translate}}</p>

    <button [disabled]="waitResolvePay" class="btn btn-primary mt-5 mb-3 w-100" (click)="confirmCustomPayment()">
        <span *ngIf="!waitResolvePay">{{"order-detail-custom-payment-action-confirm" | translate}}</span>
        <span *ngIf="waitResolvePay">{{"common-waiting" | translate}}<div *ngIf="waitResolvePay" class="spinner-border ms-2"></div></span>
    </button>
</div>

<div *ngIf="waitPay" class="d-flex flex-column justify-content-center align-items-center">
    <div class="py-2">
        <hr class="w-50 mx-auto my-4" />
    </div>
    <div class="spinner-border text-danger"></div>
</div>

<!-- Actual payment -->
<ng-container *ngIf="canPay && selectedPaymentMethod">
    <div *ngIf="!waitPay" class="d-flex justify-content-center align-items-center my-3">
        <div class="py-2">
            <hr class="w-50 mx-auto my-4" />
        </div>
        <h4 class="mb-0">{{PAYMENT_METHOD_KEY_PREFIX + selectedPaymentMethod.payment_method_type.replace("_", "-") |
            translate}}</h4>
    </div>

    <form id="payment-form">
        <div  class="position-relative" [class.disabled-overlay]="waitSave">
            <div class="position-absolute text-danger" [class.spinner-border]="waitSave">

            </div>
            <div id="payment-element">
                <!-- Elements will create form elements here -->
            </div>
        </div>

        <!-- For customer balance only -->
        <div class="mt-4"
            *ngIf="selectedPaymentMethod.payment_method_type === ordersService.config.STRIPE_METHOD_CUSTOMER_BALANCE && bankTransferInstructions">
            <h5>{{(bankTransferInstructions.amount_remaining / 100) | currency:
                bankTransferInstructions.currency.toUpperCase()}}</h5>
            <ng-container
                *ngIf="bankTransferInstructions?.financial_addresses && bankTransferInstructions.financial_addresses[0]?.iban">
                <div *ngIf="bankTransferInstructions.financial_addresses[0].iban.bic"
                    class="row d-flex justify-content-center align-items-center">
                    <div class="col">{{"payment-details-bic" | translate}}</div>
                    <div class="col">{{bankTransferInstructions.financial_addresses[0].iban.bic}}</div>
                </div>
                <div *ngIf="bankTransferInstructions.financial_addresses[0].iban.iban"
                    class="row d-flex justify-content-center align-items-center">
                    <div class="col">{{"payment-details-iban" | translate}}</div>
                    <div class="col">{{bankTransferInstructions.financial_addresses[0].iban.iban}}</div>
                </div>
                <div *ngIf="bankTransferInstructions.financial_addresses[0].iban.country"
                    class="row d-flex justify-content-center align-items-center">
                    <div class="col">{{"payment-details-country" | translate}}</div>
                    <div class="col">{{bankTransferInstructions.financial_addresses[0].iban.country}}</div>
                </div>
                <div *ngIf="bankTransferInstructions.financial_addresses[0].iban.account_holder_name"
                    class="row d-flex justify-content-center align-items-center">
                    <div class="col">{{"payment-details-account-holder-name" | translate}}</div>
                    <div class="col">{{bankTransferInstructions.financial_addresses[0].iban.account_holder_name}}
                    </div>
                </div>
                <div *ngIf="bankTransferInstructions.reference"
                    class="row d-flex justify-content-center align-items-center">
                    <div class="col">{{"payment-details-reference" | translate}}</div>
                    <div class="col">{{bankTransferInstructions.reference}}</div>
                </div>
            </ng-container>
        </div>
        <button id="submit" [disabled]="waitSave || !waitStripeLoaded || !formCompleted" class="btn btn-primary mt-5 mb-3 w-100" [hidden]="isAutoRenewal && !isOnboardingPayment && !isAutorenewalAsset">
            <span *ngIf="!waitSave">{{payButtonLabel}}</span>
            <span *ngIf="waitSave">{{"common-waiting" | translate}}</span>
        </button>
        <div class="w-100 d-flex justify-content-center">
            <button class="btn btn-tertiary text-center my-2" (click)="cancelPaymentIntent()" [disabled]="waitSave">{{"payment-method-change" |
                translate}}</button>
        </div>

        <div *ngIf="customInfoText && !isAutoRenewal">
            <hr class="w-50 mx-auto my-3" />
            <p class="text-center">{{customInfoText}}</p>
        </div>
        <div id="error-message">
            <!-- Display error message to your customers here -->
        </div>
    </form>

</ng-container>